import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \'Organisations\'}}\n\n{{outlet}}\n\n<Pages::home::organisations />\n",{ moduleName: "web-app/templates/organisations.hbs" })